export enum CreateContentOption {
  RoomTemplate = 'room-template',
  Resource = 'resource',
  Directory = 'directory',
}
